module.exports = __webpack_public_path__ + "img/preload-logo.ce5aadd2.svg";